export const generalSearchConstants = {
  emailSearchKey: "email:",
  amountSearchKey: "amount:",
  currencySearchKey: "currency:",
  statusSearchKey: "status:",
  dateSearchKey: "date:",
  countrySearchKey: "country:",
  isLast4SearchKey: "isLast4:",
};
